<div class="card" style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;">
    <div class="card-header card-header-primary">
        <div class="row">
            <div class="col-sm-12 col-md-10">
                <h4 class="card-title"><b>Crear Ticket</b></h4>
            </div>
            <div class="col-sm-12 col-md-2">
                <button mat-icon-button (click)="onCloseClick()" tabindex="0">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div class="wraper">
            <div class="container">
                <div class="row row-cols-1 row-cols-md-2 g-4 ">
                    
                    <div *ngFor="let tipo of tipos" class="col">
                        <div class="card h-100" [ngStyle]="{ 'background-color': tipo.color }" role="button" tabindex="0" (click)="modalTicket(tipo.id)" (keydown.enter)="modalTicket(tipo.id)">
                            <div class="card-body ">
                                <h2 class="card-title text-center text-white mt-5">{{ tipo.nombre }}</h2>
                                @if (enMantenimiento(tipo.id)) {
                                    <p class="selection-tickets__mant">En mantenimiento</p>
                                }
                                <!-- <p class="card-text"></p> -->
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="mb-5"></div>

</div>
